import { createFeatureSelector, createSelector } from '@ngrx/store';

import { LabresultModuleState } from '../../models/labresult.model';

export const getLabresultModuleState =
  createFeatureSelector<LabresultModuleState>('labresultModule');

export const selectLabresults = createSelector(
  getLabresultModuleState,
  (state) => state.labResults,
);

export const getLabresultPagination = createSelector(
  getLabresultModuleState,
  (state) =>
    state.pagination || {
      pageNumber: null,
      pageSize: null,
      totalNumberOfItems: null,
    },
);

export const getLabresultTotalNumberOfItems = createSelector(
  getLabresultPagination,
  (pagination) => pagination.totalNumberOfItems,
);

export const getLabresultPageNumber = createSelector(
  getLabresultPagination,
  (pagination) => pagination.pageNumber,
);
export const getLabresultPageSize = createSelector(
  getLabresultPagination,
  (pagination) => pagination.pageSize,
);
